const INSUFFICIENT_DATA_LABEL = 'Insufficient Data';
const SYNCING_LABEL = 'Syncing';

export const AVERAGE_COMMENTS = {
  TITLE: 'Comments per review',
  PREVIOUS_PERIOD: 'PREVIOUS PERIOD: {NUM_COMMENTS}',
  GO_TO_METRICS: 'Details',
};

export const CODE_REVIEWS_COMPLETED = {
  TITLE: 'Code reviews completed',
  PREVIOUS_PERIOD: 'PREVIOUS PERIOD: {NUM_CODE_REVIEWS}',
  GO_TO_METRICS: 'Details',
};

export const REVIEW_LIFECYCLE_STAT = {
  TITLE: 'Review lifecycle (hours)',
  PREVIOUS_PERIOD: 'PREVIOUS PERIOD: {NUM_HOURS}',
  GO_TO_METRICS: 'Details',
};

export const LINES_PER_REVIEW = {
  TITLE: 'Lines per review',
  PREVIOUS_PERIOD: 'PREVIOUS PERIOD: {NUM_LINES}',
  GO_TO_METRICS: 'Details',
};

export const PROJECT_BREAKDOWN = {
  TITLE: 'Project Breakdown',
  TOOLTIP:
    'Displays a language breakdown of the current project as well as a list of frameworks, total number of lines of code and total number of files (excluding generated files).',
  TOTAL_NUMBER_OF_FILES_LABEL: 'Total number of files:',
  TOTAL_LINES_OF_CODE_LABEL: 'Total lines of code:',
  FRAMEWORKS_TITLE: 'FRAMEWORKS',
  NO_FRAMEWORKS_DETECTED_LABEL: 'No frameworks detected.',
  INSUFFICIENT_DATA_LABEL,
  INSUFFICIENT_DATA_DESCRIPTION: 'No languages detected.',
  SYNCING_LABEL,
};

export const REVIEW_LIFECYCLE_DURATION = {
  TITLE: 'Review Lifecycle Duration',
  TOOLTIP:
    'The average duration in hours that a code review is in progress from open to merge.',
  HOURS_TOOLTIP_TEXT_PLURAL: '{NUM_HOURS} hours',
  HOURS_TOOLTIP_TEXT_SINGULAR: '{NUM_HOURS} hour',
  XAXIS_LABEL: 'Date',
  YAXIS_LABEL: 'Hours',
};

export const CONTRIBUTION_VOLUME = {
  TITLE: 'Contribution Volume',
  TOOLTIP: 'Displays lines added and removed for the current project.',
  LINES_ADDED_TOOLTIP_TEXT: 'Lines added:',
  LINES_REMOVED_TOOLTIP_TEXT: 'Lines removed:',
  XAXIS_LABEL: 'Date',
  YAXIS_LABEL: 'Lines',
};

export const REVIEWER_HIGHLIGHTS = {
  TITLE: 'Reviewer Highlights',
  TOOLTIP: 'Reviewers that caught the most issues.',
  ISSUES_CAUGHT_TEXT_SINGULAR: '{NUM_ISSUES_CAUGHT} issue caught',
  ISSUES_CAUGHT_TEXT_PLURAL: '{NUM_ISSUES_CAUGHT} issues caught',
  INSUFFICIENT_DATA_LABEL,
  SYNCING_LABEL,
  GO_TO_METRICS_LINK: 'Details',
};

export const AUTHOR_HIGHLIGHTS = {
  TITLE: 'Author Highlights',
  TOOLTIP: 'Authors with the highest test percentage of total code written.',
  TEST_PERCENT_LABEL: '{TEST_PERCENT} tests',
  INSUFFICIENT_DATA_LABEL,
  SYNCING_LABEL,
  GO_TO_METRICS_LINK: 'Details',
};

export const STALE_BRANCHES = {
  TITLE: 'Stale Branches',
  TOOLTIP: 'The branches that no one has committed to in the last 3 months.',
  LAST_UPDATED_TEXT: '{AUTHOR_NAME} last updated',
  NO_STALE_BRANCHES: 'No stale branches.',
  INSUFFICIENT_DATA_LABEL,
  SYNCING_LABEL,
};

export const PROJECT_DASHBOARD = {
  PAGE_TITLE: 'Project Insights',
  BREADCRUMB_TITLE: 'Insights',
  EMERGENCY_BANNER_TITLE: 'Currently unavailable:',
  EMERGENCY_BANNER_DESCRIPTION:
    'Please return to this page when Project Insights are available.',
  AVERAGE_COMMENTS,
  CODE_REVIEWS_COMPLETED,
  REVIEW_LIFECYCLE_STAT,
  LINES_PER_REVIEW,
  PROJECT_BREAKDOWN,
  REVIEW_LIFECYCLE_DURATION,
  CONTRIBUTION_VOLUME,
  REVIEWER_HIGHLIGHTS,
  AUTHOR_HIGHLIGHTS,
  STALE_BRANCHES,
};
